import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function importSpreadsheetFailure(draft: Draft<IManufacturerData>) {
  draft.importSpreadsheet.config.isLoading = false;
}

export default importSpreadsheetFailure;
